import { MarketId } from 'types/market-id.enum';
import { UserType } from 'types/shared/user-type.enum';
import { InputSettingsEvent } from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/input-settings-events.type';
import {
  OrderFeedEvent,
  ViewSiteEvent,
} from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/order-feed-events.type';
import { TimelineEvent } from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/timeline-events.type';

type DownloadEvent = CommonProps & {
  event: 'download';
  fileType: string;
  fileName: string;
  siteId: string;
};

type SelectCompanyEvent = CommonProps & {
  event: 'select_company';
  companyId: string;
  marketName: string;
  marketId: MarketId;
  marketIndustry: string; // aquaSpecies
  companyType: string; // Smolt, Supplier, Health etc
  userType: UserType;
  pageUrl: string;
};

type FilesSearchEvent = CommonProps & {
  event: 'files_search';
  searchTerm: string;
  searchResults: number;
};

type ReportsEvent = CommonProps & {
  event: 'reports';
  fileName: string;
};

type NavigationEvent = CommonProps & {
  event: 'navigationClick';
  clickText: string;
};

type Login = {
  event: 'login';
  userId: string;
};

type CommonProps = {
  pageUrl: string;
};

type EventProps =
  | OrderFeedEvent
  | TimelineEvent
  | InputSettingsEvent
  | DownloadEvent
  | ViewSiteEvent
  | SelectCompanyEvent
  | FilesSearchEvent
  | ReportsEvent
  | NavigationEvent
  | Login;

const initLogin = () => {
  let userId = window.sessionStorage.getItem('userId');
  if (!!userId) {
    userId = JSON.parse(userId);
  }
  if (!!userId) {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({ event: 'login', userId: userId });
  }
};

//@ts-ignore
const initialize = (id: string) => {
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('nonce', 'e7b814e6-d0aa-41a7-85e1-3a52d884ede8');
  scriptTag.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        var n=d.querySelector('[nonce]');
        n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${id}');`;
  document.head.insertBefore(scriptTag, document.head.childNodes[0]);
};

const push = (props: EventProps) => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({ ...props });
};

const googleTagManager = {
  push,
  initLogin,
  initialize,
};

export default googleTagManager;
